class SlideFeaturedProductMobile extends HTMLElement {
  constructor() {
    super();

    this.SlideImage = this.querySelector('.js-featured-product-custom-image');
    this.SlideInfo = this.querySelector('.js-featured-product-custom-info');
    this.galleryTop = new Swiper(this.SlideImage, {
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination-custom",
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom',
      },
	 		loop: true,
			loopedSlides: 4
    });
    this.galleryThumbs = new Swiper(this.SlideInfo, {
      spaceBetween: 10,
      centeredSlides: true,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      slideToClickedSlide: true,
			loop: true,
			loopedSlides: 4
    });
    this.galleryTop.controller.control = this.galleryThumbs;
    this.galleryThumbs.controller.control = this.galleryTop;
  }
}
customElements.define("featured-product-custom-mobile", SlideFeaturedProductMobile);

class SlideFeaturedProductDesktop extends HTMLElement {
  constructor() {
    super();

    this.Slide = this.querySelector('.js-featured-product-custom');
    new Swiper(this.Slide, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination-custom",
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        },
    });

    
  }
}
customElements.define("featured-product-custom-desktop", SlideFeaturedProductDesktop);